module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    attrs: {
      "rightVisible": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Charts")]), _vm._v(" "), _vm._l((_vm.charts), function(chart) {
    return _c('v-list-item', {
      key: chart.title,
      class: {
        'active-list-item': _vm.isChartActive(chart)
      },
      on: {
        "click": function($event) {
          _vm.activeChart = chart
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("mdi-chart-bar")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
      domProps: {
        "innerHTML": _vm._s(chart.name)
      }
    })], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c(_vm.activeChart.type, {
    tag: "component",
    attrs: {
      "chart": _vm.activeChart,
      "tenantKey": _vm.tenantKey
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7be0b24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Charts/ChartSelector.vue
// module id = 2663
// module chunks = 1